import { pushModal } from '#modals/modalsSlice';

/** Abre la «Tripulación» de un barco (puerto, Ajustes e Inicio). */
export function abrirTripulacion(fileId: string, nombre: string) {
  return pushModal({
    modal: { name: 'compartir-presupuesto', options: { fileId, nombre } },
  });
}
